interface QuantityUpdate {
  id: string;
  quantity: number;
}

interface PendingUpdate {
  latest: QuantityUpdate | null;
  promise: Promise<void>;
}

/** Keep one request in flight per item and apply the latest queued quantity. */
export const createQuantityUpdateQueue = (
  execute: (input: QuantityUpdate) => Promise<unknown>,
) => {
  const pending = new Map<string, PendingUpdate>();

  const enqueue = (input: QuantityUpdate): Promise<void> => {
    const existing = pending.get(input.id);

    if (existing) {
      existing.latest = input;
      return existing.promise;
    }

    const entry: PendingUpdate = { latest: input, promise: Promise.resolve() };
    pending.set(input.id, entry);

    const run = async (): Promise<void> => {
      const next = entry.latest;
      entry.latest = null;

      if (!next) {
        return;
      }

      await execute(next);
      await run();
    };

    entry.promise = run().finally(() => pending.delete(input.id));

    return entry.promise;
  };

  return enqueue;
};
